import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@environments/environment';
import { UserLanguageDto } from '@core/users/user.model';

import { CurrentUserDto } from './current-user.model';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserService {
  constructor(private http: HttpClient) {}

  public getCurrentUser(): Observable<CurrentUserDto> {
    return this.http.get<CurrentUserDto>(`${environment.apiUrl}/users/current`);
  }

  public postCurrentUserLanguage(language: UserLanguageDto): Observable<CurrentUserDto> {
    return this.http.post<CurrentUserDto>(`${environment.apiUrl}/users/current?language=${language}`, null);
  }
}
